// extracted by mini-css-extract-plugin
export default {"btAction":"TarefaCard_btAction__1AEvd"};